import { titleCase } from "title-case";

export function cdnUrl(url: string): string;
export function cdnUrl(url: string | null | undefined): string | null;
export function cdnUrl(url: string | null | undefined): string | null {
	const normalizedUrl = extractLogo(url)
	const result = normalizedUrl ? normalizedUrl?.replace(
		'talents-minio.dev.iglu.net/images-staging',
		'images.talentprofile.net'
	) : null;
	return result
}

export function extractLogo(logo: unknown): string | null {
	if (!logo) return null;
	if (typeof logo === 'string') return logo;
	if (typeof logo === 'object' && logo !== null) {
		const objectLogo = (logo as { url: string, optimizedUrl: string, originalUrl: string })
		return objectLogo.url || objectLogo.optimizedUrl || objectLogo.originalUrl;
	}
	return null;
}

export function getFaviconUrl(website: string | null | undefined): string | null {
	if (!website) return null;
	try {
		const domain = new URL(website).hostname;
		return `https://www.google.com/s2/favicons?domain=${encodeURIComponent(domain)}&sz=128`;
	} catch {
		return null;
	}
}

export function formatRemoteType(remoteType: string): string {
	const map: Record<string, string> = {
		global: 'Remote (Global)',
		'local-country': 'Remote (Country)',
		'local-city': 'Remote (City)',
		hybrid: 'Hybrid',
		onsite: 'On-site'
	};
	return map[remoteType] || remoteType;
}

export function formatSalary(salary: string): string {
	if (salary.includes('-')) return salary;
	if (salary.match(/^\d+$/)) return `$${parseInt(salary).toLocaleString()}`;
	return salary;
}

export function formatEmploymentType(employmentType: string): string {
	const map: Record<string, string> = {
		full_time: 'Full-time',
		contract: 'Contract'
	};
	return map[employmentType.toLowerCase()] || 'Employment';
}

export function stripHtml(html: string): string {
	return html.replace(/<[^>]*>/g, '').trim();
}

export function escapeLikePattern(value: string): string {
	return value.replace(/[%_\\]/g, '\\$&');
}

export function formatCategory(category: string): string {
  return titleCase(category.replace(/-/g, " "));
}

export function ensureHttps(url: string): string {
	const trimmed = url.trim();
	if (/^https?:\/\//i.test(trimmed)) return trimmed;
	return `https://${trimmed}`;
}